import React, { useState } from 'react'
import useSideBarData from '../../../hooks/useSideBarData';
import styles from './sidebar.module.scss'
import BoardList from './BoardList';
import BrandLogo from './BrandLogo';
function SideBar() {
    const { sideBarBoards } = useSideBarData();
    const [activeBoard, setActiveBoard] = useState();
    return (
        <div className={styles.container}>
            <BrandLogo/>
            <BoardList data={sideBarBoards} setActiveBoard={setActiveBoard} activeBoard={activeBoard} />
            
        </div>
    )
}

export default SideBar